'use client';

import {
  FeatureItem,
  FileTypeConfig,
  LandingFeatures,
  LandingHero,
  LandingUseCases,
} from '../_components';
import {
  FileText,
  Heading,
  ListChecks,
  PenTool,
  TableIcon,
} from 'lucide-react';

const docxConfig: FileTypeConfig = {
  type: 'docx',
  title: '在线翻译 Word 文档·保持完整可编辑性',
  subtitle: '商业文件、文书报告等 Word 文件的专业之选',
  description: '翻译后文档保持完整格式可编辑性',
  icon: <FileText className="w-full h-full" />,
  gradientFrom: '#3b82f6',
  gradientTo: '#2563eb',
  accentColor: 'blue',
  particleColors: ['#3b82f6', '#60a5fa', '#93c5fd'],
  accept: {
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
      '.docx',
    ],
  },
  stats: {
    users: '80万+',
    accuracy: '99.5%',
    files: '350万+',
  },
};

const docxFeatures: FeatureItem[] = [
  {
    icon: Heading,
    title: '格式零损失',
    description: '标题、页眉、表格、项目符号 100% 保留',
  },
  {
    icon: PenTool,
    title: '修订模式支持',
    description: '批注和修订记录完整保留同步翻译',
  },
  {
    icon: ListChecks,
    title: '样式完整保持',
    description: '字体、颜色、大小格式精准还原',
  },
  {
    icon: TableIcon,
    title: '复杂表格处理',
    description: '嵌套表格、合并单元格完美支持',
  },
];

const docxUseCases = [
  '商业合同',
  '项目报告',
  '图书翻译',
  '学术著作',
  '投标书',
  '企业文档',
];

const DocxPage = () => {
  return (
    <div className="w-full">
      <LandingHero config={docxConfig} />
      <LandingFeatures
        title="Word 核心优势"
        features={docxFeatures}
        gradientFrom={docxConfig.gradientFrom}
        gradientTo={docxConfig.gradientTo}
      />
      <LandingUseCases
        useCases={docxUseCases}
        gradientFrom={docxConfig.gradientFrom}
        gradientTo={docxConfig.gradientTo}
      />
    </div>
  );
};

export default DocxPage;
